import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { uniqueToken } from "../../api/DataApis";
import {Role} from "../../api/DataApis";
import axios from "axios";
import Select from 'react-select';
import Loader from "../Settings/Loader";
import { getCorporateList, EditAdminDataList, updateAdmin } from "../../Apis/Setting";



function Edit() {
  document.title = "Admin | Edit";
  let navigate = useNavigate();
 
  let params = useParams();
  let AdminID  = params?.cid;

  // State variables
    const [Name, setName] = useState("");
    const [Email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [Logo, setLogo] =  useState(null);
    const [Password, setPassword] =  useState("");
    const [selectSuperAdmin, setselectSuperAdmin] =  useState(true);
    const [filteredData, setFilteredData] = useState([]);
    const [loadings, setLoadings] = useState(false);
     const [selectedCorporate, setSelectedCorporate] = useState("");
    const [file, setfile] =  useState(null);
    const [fileName, setFileName] = useState('');
    const [AdminEditData, setAdminEditData] =  useState([]);


   const handleSuperAdminChange = (e) => { setselectSuperAdmin(e.target.checked); // Updates the state to true/false based on checkbox
     }
     const handlecorporateChange = (selectedOption) => {
      console.log("selectedOption3wrewgfreh", selectedOption);
      if(selectedOption) {
        setSelectedCorporate( selectedOption._id );
         } 
           else {
             setSelectedCorporate(null); // Reset state when cleared
           }
    }

  const handleName = (e) => setName(e.target.value);
 const handleEmailChange = (e) => setEmail(e.target.value);
 


  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleLogoChange = (e) => {
    setLogo(e.target.files[0]); // Set the first file from the input
  };

   const fetchAdminEditData = async () => {
    setLoading(true);
            try {
              const adminsData = await EditAdminDataList(AdminID);
              console.log("adminsData", adminsData);
              setAdminEditData(adminsData?.data || []);
            } catch (error) {
              console.error("Error fetching classes:", error);
            }finally {
                   setLoading(false);
            }
          };
          useEffect(() => {
           fetchAdminEditData();  // Only fetch corporate data if Role === "false"
            
          }, []);


    useEffect(() => {
      // Ensure CategoryEditData is populated and master_select_power_id exists before running the logic
      if (AdminEditData) {
        setName(AdminEditData[0]?.name);
        setEmail(AdminEditData[0]?.email);
        // setselectSuperAdmin(CorporateEditData?.is_super_admin);
        setPassword(AdminEditData[0]?.password);
        setSelectedCorporate(AdminEditData[0]?.corporate_id);
         setselectSuperAdmin(AdminEditData[0]?.is_super_admin === "true" ? true : false);
         if(AdminEditData[0]?.corporate_id) {
          setSelectedCorporate(AdminEditData[0]?.corporate_id[0]);
          }
       
      }
    }, [AdminEditData]);
  // Function to handle the update request
  const UpdateUser = async () => {
    // Show loader before API call
    Swal.fire({
      title: "Updating User...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    if (!selectedCorporate && Role === "false" && selectSuperAdmin === false) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select a Corporate before proceeding.",
      });
      return;
    }
  
    // Create FormData
    let formData = new FormData();
    formData.append("name", Name);
    formData.append("email", Email);
    if (Password) {
      formData.append("password", Password);
    }
  
    formData.append("is_super_admin", selectSuperAdmin ? "true" : "false");
  
    if (!selectSuperAdmin && selectedCorporate) {
      formData.append("corporate_id", selectedCorporate);
    }
  
    if (file) {
      formData.append("admin_image", file);
    }
  
    try {
      // Use updateAdmin function instead of axios.put
      let response = await updateAdmin(AdminID, formData);
  
      // Hide the loader
      Swal.close();
  
      if (response?.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Admin updated successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/admin/list`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update admin. Status: ${response?.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
      console.error("Error in UpdateUser:", error);
  
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };
  

  const fetchCorporate = async () => {
               try {
                 const corporatesData = await getCorporateList();
                 console.log("corporateData", corporatesData);
                 setFilteredData(corporatesData?.data || []);
               } catch (error) {
                 console.error("Error fetching classes:", error);
               }
             };
             useEffect(() => {
               if (Role === "false") {
                 fetchCorporate();  // Only fetch corporate data if Role === "false"
               }
             }, [Role]);
  const corporateOptions = filteredData?.map(corporate => ({
    value: corporate._id,
    label: `${corporate.corporate_name} (${corporate?.email})`,
    _id: corporate._id,
  }));
  // Re-fetch users whenever searchTerm changes
 
  console.log("password", Password);
  console.log("selectSuperAdmin", selectSuperAdmin);
  console.log("selectedCorporate", selectedCorporate);

  const handleInputImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setfile(selectedFile);
     setFileName(selectedFile.name);
     console.log('Selected file:', selectedFile);
    }
    // Reset the input value to allow re-selection of the same file if needed
    e.target.value = null;
  };
  console.log("AdminEditData", AdminEditData);
  return (
    <>
       {loading ? (
      <Loader />
    ) : (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Edit Admin
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                            Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleName}
                                value={Name}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                   

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Email
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="email"
                                onChange={handleEmailChange}
                                className="form-control"
                                id="email"
                                name="email"
                                value={Email}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                    
                      
                     
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Password
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="password"
                                onChange={handlePasswordChange}
                                className="form-control"
                                id="password"
                                name="password"
                                value={Password}
                                autoComplete="new-password"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                          {Role === "false" && (
                                                      <>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Super Admin
                            </label>
                            <div className="col-sm-6">
      <input
        type="checkbox"
        onChange={handleSuperAdminChange}  // Enable the onChange handler to update state
       
        id="superAdmin"
        name="superAdmin"
        checked={selectSuperAdmin} // Bind the checkbox to the state
      />

      
       
    </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {selectSuperAdmin=== false && (
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              Select Corporate
                            </label>
                            <div className="col-sm-6">
                            <Select
  options={corporateOptions}
  onChange={handlecorporateChange}
  value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate) : null}
  placeholder="Select Corporate"
  isClearable
  styles={{
    control: (base) => ({
      ...base,
      height: '38px', 
      width: '100%',
      boxShadow: 'none',
      minWidth: '0',
      flex: 1,
    }),
  }}
/>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                       )}
                       </>
                          )}

<div className="form-group">
  <div className="row">
    <label htmlFor="fileInput" className="col-sm-2 control-label">
      Select Image
    </label>
    <div className="col-sm-6">
      <input
        type="file"
        onChange={handleInputImageChange}
        className="form-control"
        id="fileInput"
        name="fileInput"
      />
      {fileName && (
        <p>Selected File: {fileName}</p>
      )}
    </div>
  </div>
</div>
                      
                          <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={UpdateUser}
                              value="Update"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        )}
    </>
    
  );
}

export default Edit;
